import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";
import FormPrint from "./formPrint";
import { Autocomplete, Button, Grid, TextField, Toolbar } from "@mui/material";
import html2pdf from "html2pdf.js";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";

const MultiplePrintForm = () => {
  const location = useLocation();
  const [ids, setIds] = useState([]);
  const [FormData, setFormData] = useState([]);
  const elementRef = useRef(null);
  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);
  const [electronicSign, setElectronicSign] = React.useState(false);
  const fetchFormData = () => {
    try {
      let SQLQuery = {
        query: `SELECT id, templateId FROM reportValues WHERE id IN (${ids.join(
          ","
        )}) ORDER BY id DESC`,
      };

      axiosWithToken.post(BASE_URL + `dynamic`, SQLQuery).then((res) => {
        let data = res.data;
        setFormData(data);
      });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

 const generatePDF = async () => {
  setDownloadPdfloading(true);
  try {
    const element = elementRef.current;

    const waitForImagesToLoad = (element) => {
      const images = element.querySelectorAll('img');
      const promises = Array.from(images).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        });
      });
      return Promise.all(promises);
    };

    await waitForImagesToLoad(element);

    await html2pdf()
      .from(element)
      .set({
        margin: [5, 5, 5, 5],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        html2canvas: {
          scale: 1.5,       // Reduce for smaller size
          useCORS: true,
        },
        image: {
          type: "jpeg",     // JPEG is smaller than PNG
          quality: 0.7,     // Lower quality = smaller file
        },
          jsPDF: {
            orientation: "portrait",
            unit: "pt",
            format: "a4",
            compress: true,
          },
        })
      .save("form.pdf");

    setDownloadPdfloading(false);
  } catch (error) {
    console.error("Error generating PDF:", error);
    setDownloadPdfloading(false);
  }
};


  useEffect(() => {
    if (ids?.length > 0) fetchFormData();
  }, [ids]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const idsParam = searchParams.get("ids");
    if (idsParam) {
      const idsArray = idsParam.split(",").map((id) => parseInt(id));
      setIds(idsArray);
    }
  }, [location.search]);
  return (
    <>
    <Grid container spacing={2} align="left" sx={{p:2}}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
                <Autocomplete
                  size="small"
                  id="certificate-certificateviewelectronicsign"
                  options={[
                    { id: 1, label: "With Signed And Stamp" },
                    { id: 2, label: "Without Signed And Stamp" },
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} label="Signed And Stamp" />
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (
                      newInputValue === "With Signed And Stamp" ||
                      newInputValue === ""
                    ) {
                      setElectronicSign(true);
                    } else if (
                      newInputValue === "Without Signed And Stamp"
                    ) {
                      setElectronicSign(false);
                      }
                  }}
                />
              </Grid>
     </Grid>
      <Toolbar
            style={{
              padding: "0px",
              overflow: "auto",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Button
              variant="contained"
              size="small"
              sx={{ marginRight: "20px" }}
              onClick={generatePDF}
            >
              Report Print
            </Button>
          </Toolbar>
    <div
     id="formToPrint"
     ref={elementRef}
    >
      {FormData?.sort((a, b) => a.id - b.id)?.map((ele) => {
        return (
          <div style={{ pageBreakAfter: 'always', marginTop:"22px" }} >
            <FormPrint 
            selectedFormID ={ele?.id}
            selectedTemplateID={ele?.templateId}
            multiple={electronicSign}            
            />
            
          </div>
        );
      })}
    </div>

 {downloadPdfloading && (
        <DownloadPdfLoaderModal loading={downloadPdfloading} name={"Pdf"} />
      )}

    </>
  );
};

export default MultiplePrintForm;
